if (!window.StepLabsSidecart) {
  window.StepLabsSidecart = {
    async open(errorMessage) {
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));

      for (let attempt = 0; attempt <= 50; attempt += 1) {
        if (typeof window.Rebuy?.SmartCart?.show === 'function') {
          window.Rebuy.SmartCart.show();
          return;
        }

        const cartTrigger = document.querySelector('[data-js-cart-icon]');
        if (document.querySelector('.quick-cart') && cartTrigger) {
          // Keep the header's drawer handler, but never follow its cart URL.
          cartTrigger.addEventListener('click', (event) => event.preventDefault(), { once: true });
          cartTrigger.click();
          return;
        }

        if (attempt < 50) await new Promise((resolve) => window.setTimeout(resolve, 100));
      }

      throw new Error(errorMessage);
    },
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('[data-sidecart-form]')) return;
    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;

    const button = form.querySelector('[type="submit"]');
    if (button.disabled) return;
    const status = form.querySelector('[data-sidecart-status]');
    status.textContent = '';
    status.removeAttribute('data-error');
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    const root = window.Shopify?.routes?.root || '/';

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const result = await response.json();
      if (!response.ok) {
        throw new Error(typeof result.description === 'string' ? result.description : form.dataset.cartError);
      }
      status.textContent = form.dataset.cartAdded;
      await window.StepLabsSidecart.open(form.dataset.sidecartError);
    } catch (error) {
      console.error('[c-sidecart] Cart action failed:', error);
      status.setAttribute('data-error', '');
      status.textContent = error instanceof Error ? error.message : form.dataset.cartError;
    } finally {
      form.removeAttribute('aria-busy');
      button.disabled = false;
    }
  });
}
